import React, { useState } from "react";
import { Box, Button, Dialog, DialogContent, DialogTitle, Grid, Typography } from "@mui/material";
import moment from "moment";
import Notify from "../../../../Notify";
import AgregarCoordenadasEnv from "../../NuevoPedido/agregarCoordenadas/AgregarCoordenadasEnv";
import AltaDireccionEnv from "../../../clientesEnvasado/fichaCliente/direcciones/AltaDireccionEnv";
import EditarClientePedido from "../../NuevoPedido/edicionCliente/EditarClientePedido";
import DatosPedidoForm from "../../NuevoPedido/componetizado/components/DatosPedidoForm";
import ListaLineasPedido from "../../NuevoPedido/componetizado/components/ListaLineasPedido";
import { useNotificacion } from "../../NuevoPedido/componetizado/hooks/useNotificacion";
import EncabezadoEditar from "./components/EncabezadoEditar";
import ClienteEditarCard from "./components/ClienteEditarCard";
import { useDireccionEditar } from "./hooks/useDireccionEditar";
import { useLineasEditarPedido } from "./hooks/useLineasEditarPedido";
import { useGuardarEdicion } from "./hooks/useGuardarEdicion";

// Versión componetizada de ../EditarPedido.js. Misma interfaz (props.open,
// props.setOpen, props.dataPedido). Las líneas usan los mismos componentes y
// reglas que Nuevo Pedido (envases, promo / seña, validaciones).
function EditarPedido(props) {
  const { dataPedido } = props;

  // "tabla" = el modal principal está visible. Se oculta mientras está
  // abierto alguno de los sub-modales.
  const [tabla, setTabla] = useState(true);
  const [nuevaDireccion, setNuevaDireccion] = useState(false);
  const [editarCliente, setEditarCliente] = useState(false);
  const [abrirCoordenadas, setAbrirCoordenadas] = useState(false);

  const [clienteSeleccionado] = useState({
    id: dataPedido.id_cliente,
    razon_social: dataPedido.cliente,
  });
  const [datosPedido, setDatosPedido] = useState({
    observaciones: dataPedido.observaciones,
    fecha_para: moment(dataPedido.fecha_para, "DD/MM/YYYY HH:mm").format("YYYY-MM-DD HH:mm:ss"),
  });
  const [fechaModificada, setFechaModificada] = useState(false);
  const [pedidoCambio, setPedidoCambio] = useState(dataPedido.pedido_cambio === 1);

  const handleClose = () => {
    props.setOpen(false);
  };

  const { notificacion, notificarError, notificarExito, handleCloseNotificacion } =
    useNotificacion({ onCerrarModal: handleClose });

  const { direcciones, direccionSeleccionada, setDireccionSeleccionada, agregarCoordenadas } =
    useDireccionEditar({ dataPedido, tabla });

  const lineas = useLineasEditarPedido({ dataPedido, tabla, onErrorCarga: notificarError });

  const { disabled, guardar, guardadoParcial } = useGuardarEdicion({
    dataPedido,
    clienteSeleccionado,
    direccionSeleccionada,
    datosPedido,
    fechaModificada,
    pedidoCambio,
    datosRenglon: lineas.datosRenglon,
    eliminados: lineas.eliminados,
    onGuardado: () => notificarExito("Pedido actualizado."),
    onError: notificarError,
  });

  // Igual que el original: cambiar la fecha marca el pedido para reprogramar.
  const handleDatosPedidoChange = (e) => {
    if (e.target.name === "fecha_para") setFechaModificada(true);
    setDatosPedido({ ...datosPedido, [e.target.name]: e.target.value });
  };

  const abrirSubModal = (setSubModal) => {
    setSubModal(true);
    setTabla(false);
  };

  const cerrarSubModal = (setSubModal) => {
    setSubModal(false);
    setTabla(true);
  };

  // setOpen que reciben AltaDireccionEnv / EditarClientePedido.
  const setOpenSubModal = (setSubModal) => (value) => {
    if (value === false) {
      cerrarSubModal(setSubModal);
    } else {
      abrirSubModal(setSubModal);
    }
  };

  return (
    <div>
      {tabla ? (
        <Dialog fullWidth open={props.open} onClose={() => props.setOpen(false)} maxWidth="xl">
          {notificacion && notificacion.open ? (
            <Notify
              // Notify toma "open" sólo al montarse: la key lo remonta si cambia el aviso.
              key={notificacion.severity + notificacion.mensaje}
              mensaje={notificacion.mensaje}
              open={notificacion.open}
              color={notificacion.color}
              duracion={notificacion.duracion}
              handleClose={handleCloseNotificacion}
              severity={notificacion.severity}
            />
          ) : null}
          <Box justifyContent="center" backgroundColor="#1F618D">
            <DialogTitle>
              <Typography variant="h6" align="center" color="#ffffff">
                Editar Pedido N°{dataPedido.id}
              </Typography>
            </DialogTitle>
          </Box>
          <DialogContent>
            {guardadoParcial ? (
              <Box
                sx={{
                  backgroundColor: "#FADBD8",
                  border: "1px solid",
                  borderColor: "error.main",
                  borderRadius: 1,
                  p: 1,
                  mb: 1,
                  textAlign: "center",
                  fontWeight: "bold",
                }}
              >
                Parte de los cambios ya se guardó. Presione "Guardar" para reintentar lo
                pendiente.
              </Box>
            ) : null}
            {/* Con un guardado parcial el formulario se bloquea: los reintentos
                envían los datos del primer intento. */}
            <Box
              sx={guardadoParcial ? { pointerEvents: "none", opacity: 0.6 } : undefined}
              aria-disabled={guardadoParcial}
            >
              <Grid container spacing={1}>
                <EncabezadoEditar
                  cliente={dataPedido.cliente}
                  direcciones={direcciones}
                  direccionSeleccionada={direccionSeleccionada}
                  onDireccionChange={setDireccionSeleccionada}
                  mostrarAgregarCoordenadas={agregarCoordenadas}
                  onAgregarCoordenadas={() => abrirSubModal(setAbrirCoordenadas)}
                  onNuevaDireccion={() => abrirSubModal(setNuevaDireccion)}
                />

                <ClienteEditarCard
                  clienteSeleccionado={clienteSeleccionado}
                  direccionSeleccionada={direccionSeleccionada}
                  sisvenPedido={dataPedido.sisven_id}
                  onEditarCliente={() => abrirSubModal(setEditarCliente)}
                />

                <Grid item xs={12} mr={3}>
                  {direccionSeleccionada ? (
                    <DatosPedidoForm
                      datosPedido={datosPedido}
                      onChange={handleDatosPedidoChange}
                      pedidoCambio={pedidoCambio}
                      onPedidoCambioChange={(e) => setPedidoCambio(e.target.checked)}
                    />
                  ) : null}

                  {direccionSeleccionada ? (
                    lineas.cargandoRenglones ? (
                      <Typography variant="body2" color="text.secondary" sx={{ m: 1 }}>
                        Cargando productos del pedido...
                      </Typography>
                    ) : (
                      <ListaLineasPedido lineas={lineas} />
                    )
                  ) : null}
                </Grid>
              </Grid>
            </Box>

            <Grid
              mt={1}
              container
              direction="row"
              justifyContent="space-between"
              alignItems="center"
            >
              <Button variant="contained" onClick={() => props.setOpen(false)} color="error">
                Volver
              </Button>
              <Button disabled={disabled} variant="contained" onClick={guardar} color="success">
                Guardar
              </Button>
            </Grid>
          </DialogContent>
        </Dialog>
      ) : null}

      {abrirCoordenadas ? (
        <AgregarCoordenadasEnv
          open={abrirCoordenadas}
          setOpen={setAbrirCoordenadas}
          direccionSeleccionada={direccionSeleccionada}
          onClose={() => cerrarSubModal(setAbrirCoordenadas)}
        />
      ) : null}

      {nuevaDireccion ? (
        <AltaDireccionEnv
          open={nuevaDireccion}
          setOpen={setOpenSubModal(setNuevaDireccion)}
          cliente={clienteSeleccionado}
          onClose={() => cerrarSubModal(setNuevaDireccion)}
        />
      ) : null}

      {editarCliente ? (
        <EditarClientePedido
          open={editarCliente}
          setOpen={setOpenSubModal(setEditarCliente)}
          cliente={clienteSeleccionado}
          onClose={() => cerrarSubModal(setEditarCliente)}
        />
      ) : null}
    </div>
  );
}

export default EditarPedido;
